<template>
    <div class="our-oferings">    
        <div class="features-area bg-F7F7FF">

        <div class="container">
            <div class="section-top-title">
                <span class="sub-title text-uppercase text-uppercase text-center">Our Offerings</span>
                <h2 class="title-build-ai"> Discover our trust-driven, AI-enhanced software solutions, crafted for your
                    success.</h2>
            </div>
            <div class="row justify-content-center">

                <div class="col-lg-4 col-sm-6 col-md-6">
                    <div class="features-item new-feature">
                        <div class="icon"><i class="ri-eye-line"></i></div>
                        <h3>Ready-to-Launch Mobile App Services</h3>
                        <p>Get market-ready mobile apps tailored to your industry, with AI-powered features for smarter
                            user experiences, minimal time-to-market, and maximum impact.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-6 col-md-6">
                    <div class="features-item new-feature">
                        <div class="icon bg2"><i class="ri-stack-line"></i></div>
                        <h3>System, API & AI Model Integration</h3>
                        <p>Seamlessly connect third-party APIs, CRMs, ERPs, payment gateways, and AI models to unify and
                            automate your business operations.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-6 col-md-6">
                    <div class="features-item new-feature">
                        <div class="icon bg3"><i class="ri-leaf-line"></i></div>
                        <h3>Custom Development Services</h3>
                        <p>We build bespoke, AI-enabled software 
                            solutions that solve your unique business challenges, from
                            web, mobile, or enterprise-grade.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-6 col-md-6">
                    <div class="features-item new-feature">
                        <div class="icon bg4"><i class="ri-secure-payment-line"></i></div>
                        <h3>Digital Marketing & Analytics</h3>
                        <p>Boost your brand’s visibility with data-driven strategies leveraging AI for advanced
                            audience targeting, predictive insights, and performance optimization.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-6 col-md-6">
                    <div class="features-item new-feature">
                        <div class="icon bg5"><i class="ri-cloud-line"></i></div>
                        <h3>CRM & Web Development</h3>
                        <p>From responsive websites to high-performance web apps, enriched with AI-driven
                            personalization and automation to improve customer engagement.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-6 col-md-6">
                    <div class="features-item new-feature">
                        <div class="icon bg6"><i class="ri-pie-chart-2-line"></i></div>
                        <h3>And More...</h3>
                        <p>Cloud solutions, DevOps, product strategy, UI/UX design, AI chatbots, and intelligent
                            automation, and whatever your vision, we help you bring it to life.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>


   


  

  

   


</template>
<style>
h2.title-build-ai {
    padding-bottom: 40px;
}

.section-top-title span.sub-title {
    background: linear-gradient(44.44deg, #ed2775 7.79%, #ff7448 94.18%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    letter-spacing: .1em;
    font-weight: 600;
    margin-bottom: 10px;
    display: block;
}

.new-feature p {
    line-height: 26px;
}
</style>
<script>
export default {
    name: 'IncludedBestFeatures'
}
</script>